import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/**
 * Expirarile aplicatiilor de business - `v4/api/src/Controller/BusinessAppsExpiryController.php`.
 *
 *   GET  /business-apps/expiring?days=90   lista "Expiring" (Overview > Applications)
 *   GET  /business-apps/{id}/expiry        datele, certificatele TLS, bannerul fisei
 *   POST /business-apps/{id}/expiry        salveaza datele
 */

export type ExpiryKind = 'support' | 'license' | 'renewal' | 'cert'

/** `expired` (<= 0 zile), `soon` (<= 7), `near` (<= 30), `ahead` (<= 60), `later`. */
export type ExpiryLevel = 'expired' | 'soon' | 'near' | 'ahead' | 'later'

export type ExpiryItem = {
  kind: ExpiryKind
  ref: string
  what: string
  label: string
  /** YYYY-MM-DD */
  date: string
  /** zile ramase; negative dupa expirare */
  days: number
  level: ExpiryLevel
  /** "Support contract expires in 23 days" */
  text: string
  deviceId: number | null
  deviceName: string | null
  issuer: string | null
}

export type ExpiryDates = {
  supportContractEnd: string | null
  licenseExpires: string | null
  renewalDate: string | null
  licenseNote: string
}

export type AppExpiryPage = {
  ready: boolean
  message?: string
  canEdit?: boolean
  dates?: ExpiryDates
  items?: ExpiryItem[]
  /** ce a intrat in primul prag (60 de zile) sau a expirat */
  banner?: ExpiryItem[]
  thresholds?: number[]
}

export type ExpiringItem = ExpiryItem & {
  appId: number
  appName: string
  companyId: number
  companyName: string
  criticality: number
}

export type ExpiringPage = {
  ready: boolean
  message?: string
  days: number
  alertDays?: number
  companyId?: number
  items: ExpiringItem[]
}

export function appExpiryQuery(appId: number) {
  return queryOptions({
    queryKey: ['business-apps', 'expiry', appId],
    queryFn: () => apiGet<AppExpiryPage>(`/business-apps/${appId}/expiry`),
    enabled: appId > 0,
  })
}

export function expiringAppsQuery(days = 90) {
  return queryOptions({
    queryKey: ['business-apps', 'expiring', days],
    queryFn: () => apiGet<ExpiringPage>(`/business-apps/expiring?days=${days}`),
  })
}

export type ExpiryWritten = { status: 'OK' | 'ERROR'; message: string }

export function saveAppExpiry(
  appId: number,
  fields: { support_contract_end: string; license_expires: string; renewal_date: string; license_note: string },
) {
  return apiPost<ExpiryWritten>(`/business-apps/${appId}/expiry`, fields)
}
